// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__a0cdF","actionsCol":"EnrolledClinics_actionsCol__3cHIC"};